var PageNote = require('../pgNote');

module.exports = PageNote.extend({
    init: 'G',
    desc: 'Graphic',
    iconClass:  'icon-picture',
    notCreatable: true,
    getNoteClass: function(isSVG) {
        var c = PageNote.prototype.getNoteClass.call(this);
        return isSVG
            ? c
            : c + ' ' + c + '-FDD';
    },
    getIconHoverLbl: function(isSVG) {
        var l = PageNote.prototype.getIconHoverLbl.call(this);
        return isSVG
            ? l
            : 'Legacy FDD ' + l + '\n' + '(Not rendered on page)';
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/models/page/noteTypes/fddGraphicNote.js
 ** module id = 290
 ** module chunks = 0
 **/